module.exports = __webpack_public_path__ + "img/bask_right_sel.1d3be6e1.png";